import { useNavigate } from 'react-router-dom';

// project imports
import { GuardProps } from 'types';
import { useEffect } from 'react';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }: GuardProps) => {
    const navigate = useNavigate();
    const isValidToken: string = localStorage.getItem('refreshToken') || '';
    const isLoggedIn: string = localStorage.getItem('isLoggedIn') || '';

    useEffect(() => {
        if (!isLoggedIn && !isValidToken) {
            navigate('/login', { replace: true });
        }
    }, [navigate]);

    return children;
};

export default AuthGuard;
